import { useState } from "react";
import { View } from "react-native";
import { Button } from "~/components/ui/Button";
import { CaptionText } from "~/components/ui/Text";
import { exportMyData } from "~/services/account-data";
import { spacing, useTheme } from "~/styles/theme";
import { saveJsonExport } from "~/utils/export-file";

/** Downloads (or shares) everything stored for the account as a JSON file. */
export function ExportData() {
  const { colors } = useTheme();
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState("");

  const run = async () => {
    setPending(true);
    setMessage("");
    try {
      await saveJsonExport(await exportMyData(), "durance-account-data.json");
      setMessage("Your data was exported.");
    } catch (error) {
      setMessage(
        error instanceof Error && error.message
          ? error.message
          : "Could not export your data.",
      );
    } finally {
      setPending(false);
    }
  };

  return (
    <View style={{ gap: spacing.sm }}>
      <Button
        label={pending ? "Preparing…" : "Export my data"}
        variant="secondary"
        fullWidth
        disabled={pending}
        onPress={() => void run()}
      />
      {message ? (
        <CaptionText color={colors.muted}>{message}</CaptionText>
      ) : null}
    </View>
  );
}
